import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-message__header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "error-message__errorcode" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MessageLayout = _resolveComponent("MessageLayout")!

  return (_openBlock(), _createBlock(_component_MessageLayout, {
    title: _ctx.title,
    errorcode: _ctx.errorcode,
    class: "error-message"
  }, {
    image: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: `${_ctx.config.publicPath}triangle-warning.svg`,
          alt: "warning",
          class: "error-message__image"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.errorcode), 1)
      ])
    ]),
    action: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: _ctx.tryAgain }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Try Again")
        ])),
        _: 1,
        __: [0]
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createTextVNode(" Oops! Something went wrong: nobody said 100% reliability. "))
    ]),
    _: 1,
    __: [1]
  }, 8, ["title", "errorcode"]))
}